define('models/modals/organization/index',['require','lib/utils','models/base/model','models/base/modal'],function(require) {
    'use strict';

    var utils = require('lib/utils'),
        Model = require('models/base/model'),
        ModalModel = require('models/base/modal');

    function parseTimetable(timetable) {
        var result = [];

        if (timetable) {
            var ttParts = timetable.split(';');
            if (ttParts.length === 7) {
                ttParts.forEach(function(dayItem, index){
                    var dParts = dayItem.split(',');
                    var day = { dayOff: false, withoutLunch: false, name: utils.decodeDayName(index) };
                    if(dParts.length >= 2 && dParts[0].length > 0 && dParts[1].length > 0){
                        day.start = dParts[0];
                        day.end = dParts[1];

                        if(dParts.length === 4 && dParts[2].length > 0 && dParts[3].length > 0){
                            day.lStart = dParts[2];
                            day.lEnd = dParts[3];
                        }else {
                            day.withoutLunch = true;
                        }
                    }else{
                        day.dayOff = true;
                    }
                    result.push(day);
                });
            }
        }

        return result;
    }

    var OrganizationModalContent = Model.extend({
        urlPath: function() {
            return '/organization/' + this.get('id');
        },
        defaults: {
            id: null,
            name: null,
            countryName: null,
            townName: null,
            geolink: null,
            fax: null,
            skype: null,
            timetable: null,
            factAddress: null,
            address: null,
            phone: null,
            email: null,
            site: null,
            ogrn: null,
            inn: null,
            kpp: null,
            bank: null,
            bik: null,
            ks: null,
            rs: null,
            additionalInfo: null,
            condPayment: null,
            condDelivery: null,
            favoriteId: null,

            phones: [],

            haveDetails: false,

            users: [],
            storages: [],
            comments: []

            // favoriteId: null,
            // Name: '',
            // CountryName: '',
            // TownName: '',
            // _factAddress: '',
            // _address: '',
            // _phone: '',
            // phones: [],
            // geolink: '',
            // fax: '',
            // skype: '',
            // _email: '',
            // _site: '',
            // timetable: '',
            // _timetable: [],
            // haveDetails: false,
            // _ogrn: '',
            // _inn: '',
            // _kpp: '',
            // _bank: '',
            // _bik: '',
            // _ks: '',
            // _rs: '',
            // additionalInfo: '',
            // users: []
        },
        initialize: function() {
            Model.prototype.initialize.apply(this, arguments);
        },
        parse: function(data){
            data.Name = data.name ? data.name.toUpperCase() : '';
            data.phones = (data.phone && data.phone.length) ? data.phone.split(',') : [];
            data.timetable = parseTimetable(data.timetable);

            var detailsFields = ['ogrn', 'inn', 'kpp', 'bank', 'bik', 'ks', 'rs', 'additionalInfo'];
            detailsFields.forEach(function(fieldName){
                var value = data[fieldName];
                if (value && value.length) {
                    data.haveDetails = true;
                }
            });

            console.log('organization', data);

            return data;
        }
    });

    var OrganizationModalModel = ModalModel.extend({
        defaults: {
            'title': 'Контактная информация',
            'buttons': [
                { caption: 'Добавить в избранное', className: 'btn-warning pull-left', 'action': 'save', icon: 'star', iconClass: 'org-card-btn-add' },
                { caption: 'Удалить из избранного', className: 'btn-warning pull-left', 'action': 'remove', icon: 'star', iconClass: 'org-card-btn-remove' },
                { caption: 'Закрыть', className: '', 'action': 'cancel' }
            ],
            body: ''
        },
        constructor: function() {
            ModalModel.apply(this, arguments);

            var self = this;
            this.content = new OrganizationModalContent({
                id: this.get('id')
            });
            this.content.on('afterLoad', function() {
                self.trigger('afterLoad');
            });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.content.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        }
    });

    return OrganizationModalModel;
});

